import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/general-info'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'general_info_index',
          component: Index,
          meta: {
            permissions: ['administrator', 'owner'],
          },
        },
      ],
    },
  ],
};
